<template>
  <div class="main">
    <!-- <div class="home-btn" @click="goPage('/')">マイページへ</div> -->
    <div class="pay-main-warp column">
      <div class="title-box">
        <div class="title">料金プラン</div>
      </div>
      <div style="margin-bottom: 20px">
        <div class="home-btn" @click="goPage('/')">マイページへ</div>
      </div>
      <div class="lists-box row">
        <div
          class="lists-item column"
          v-for="(item, index) in list"
          v-if="item.name != '法人プラン' || revert"
        >
          <div class="title" v-text="item.name"></div>
          <div class="price-box row">
            <!-- 認定ファシリテータープランに価格を追加_23/04/01 -->
            <!-- <div
              class="price"
              v-text="
                item.name == '法人プラン' ||
                (item.name == '基本プラン' && !revert) ||
                (item.name == '認定ファシリテータープラン' && !revert)
                  ? '未定/月払い'
                  : numberWithCommas(item.priceCount) + '円/月払い'
              "
              v-if="item.priceCount != null"
            ></div>
            <div class="price" v-text="item.price" v-else></div> -->
            <div
              class="price"
              v-text="
                item.name == '法人プラン' ||
                // (item.name == '基本プラン' && !revert) ||
                // (item.name == '認定ファシリテータープラン' && !revert)
                //   ? '未定/月払い'
                //   : numberWithCommas(item.priceCount) + '円/月払い'
                (item.name == '基本プラン' && !revert)
                  ? '未定/月払い'
                  : item.name == '認定ファシリテータープラン'
                  ? '3,300円/月払い'
                  : numberWithCommas(item.priceYearCount) + '円/月払い'
              "
              v-if="item.priceCount != null"
            ></div>
          </div>
          <div class="price-box row" v-if="item.priceCount != null">
            <!-- 認定ファシリテータープランに価格を追加_23/04/01 -->
            <!-- <div
              class="price"
              v-text="
                item.name == '法人プラン' ||
                (item.name == '基本プラン' && !revert) ||
                (item.name == '認定ファシリテータープラン' && !revert)
                  ? '未定/年払い'
                  : numberWithCommas(item.priceYearCount) + '円/年払い'
              "
            ></div> -->
            <div
              class="price"
              v-text="
                item.name == '法人プラン' ||
                // (item.name == '基本プラン' && !revert) ||
                // (item.name == '認定ファシリテータープラン' && !revert)
                //   ? '未定/年払い'
                //   : numberWithCommas(item.priceYearCount) + '円/年払い'
                (item.name == '基本プラン' && !revert)
                  ? '未定/年払い'
                  : item.name == '認定ファシリテータープラン'
                  ? '33,000円/年払い'
                  : numberWithCommas(item.priceYearCount) + '円/年払い'
              "
            ></div>
          </div>
          <div class="des" v-html="item.describe"></div>
          <div class="item-list" v-for="(ite, idx) in item.jurisdiction">
            <i class="el-icon-success"></i>&nbsp;{{ ite }}
          </div>
          <div
            class="des"
            v-if="item.priceCount == null && !revert"
            style="font-size: 16px; color: block; line-height: 20px"
          >
            ※β版リリースのため、<span style="color: red"
              >期間限定で基本プランと同じサービスが利用可能</span
            >となっております。
          </div>
          <div class="btns-box row row-center">
            <div
              v-if="
                item.name == '法人プラン' ||
                (item.name == '基本プラン' && !revert) ||
                (item.name == '認定ファシリテータープラン' && revert)
              "
              class="disabled-btn"
            >
              準備中
            </div>
            <el-button
              v-else-if="item.price != '無料/月' && item.name != my_plan"
              @click="
                tobuy(
                  item.id,
                  item.price,
                  item.describe,
                  item.name,
                  item.priceYearCount
                )
              "
              class="join-btn"
              style="font-weight: 700 !important"
              >購入する
            </el-button>
            <div
              v-else-if="item.price != '無料/月' && item.name == my_plan"
              class="purchased-btn"
            >
              購入済み
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="compare-table-container">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th
              rowspan="2"
              style="color: #577a9a; background-color: white"
            ></th>
            <th class="col-free" style="background: #dbdbdb">フリ一プラン</th>
            <th class="col-h1">基本プラン</th>
            <th class="col-h1">認定ファシリテータープラン</th>
            <th class="col-h1" v-if="revert">法人プラン</th>
          </tr>
          <tr>
            <th class="col-free">無料</th>
            <th
              class="col-h2"
              v-html="
                revert
                  ? '330円/月払い<br>3,300円/年払い'
                  : '未定/月払い<br>未定/年払い'
              "
            ></th>
            <th
              class="col-h2"
              v-html="
                revert
                  ? '4,950円/月払い<br>49,500円/年払い'
                  : '3,300円/月払い<br>33,000円/年払い'
              "
            ></th>
            <th class="col-h2" v-if="revert">未定/月払い<br />未定/年払い</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="row-h">過去のプレイ結果を見る</td>
            <td class="col-free">
              <!--<i class="el-icon-check" v-if="!revert"></i>-->
            </td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">プレイヤー参加</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">ルームの作成</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">同時ルーム作成</td>
            <td class="col-free">1ルーム</td>
            <td>1ルーム</td>
            <td>最大5ルーム</td>
            <td v-if="revert">最大30ルーム</td>
          </tr>
          <tr>
            <td class="row-h">１人プレイ</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">1on1プレイ (２人)</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">複数人プレイ (3人)</td>
            <td class="col-free">
              <!--<i class="el-icon-check" v-if="!revert"></i>-->
            </td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">複数人プレイ (4人)</td>
            <td class="col-free">
              <!--<i class="el-icon-check" v-if="!revert"></i>-->
            </td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">1ル―ム最大プレイ人数</td>
            <td class="col-free">2名</td>
            <td>4名</td>
            <td>4名</td>
            <td v-if="revert">4名</td>
          </tr>
          <tr>
            <td class="row-h">観戦者として参加</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">招待URL発行</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">招待コード発行</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">ルーム名の設定</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">テーマ設定</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">手札の公開/非公開設定</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">カードコピー機能</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">制限時間の変更</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">パス機能</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">スキップ機能 (ルーム作成時)</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">一時停止機能 (ルーム作成時)</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">終了機能 (ルーム作成時)</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">結果表示</td>
            <td class="col-free"><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">画像作成</td>
            <td class="col-free"><i class=""></i></td>
            <td><i class=""></i></td>
            <td><i class=""></i></td>
            <td v-if="revert"><i class=""></i></td>
          </tr>
          <tr>
            <td class="row-h">プレイ結果データ保存</td>
            <td class="col-free">
              <!--<i class="el-icon-check" v-if="!revert"></i>-->
            </td>
            <td><i class="el-icon-check"></i></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
          <tr>
            <td class="row-h">結果データの対象</td>
            <td class="col-free"></td>
            <td>本人のみ</td>
            <td>プレイヤー全員</td>
            <td v-if="revert">プレイヤー全員</td>
          </tr>
          <tr>
            <td class="row-h">独自URL発行</td>
            <td></td>
            <td></td>
            <td><i class="el-icon-check"></i></td>
            <td v-if="revert"><i class="el-icon-check"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
    <el-dialog
      style="border-radius: 15px"
      :title="dtitle"
      :visible.sync="centerDialogVisible"
      custom-class="confirmContent"
      top="30vh"
      width="378px"
      center
    >
      <span v-html="des.replace('\n', '<br>')"></span>
      <div class="colbtns">
        <el-button
          class="join-btn"
          style="font-weight: 700 !important"
          @click="createPrice('month')"
          >1ヶ月プラン</el-button
        >
        <el-button
          class="join-btn"
          style="font-weight: 700 !important"
          @click="createPrice('year')"
          >1年プラン</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      style="border-radius: 15px"
      :title="dtitle1"
      :visible.sync="centerDialogVisible1"
      custom-class="confirmContent"
      top="30vh"
      width="378px"
      center
    >
      <div slot="title" class="header-title" :style="{ color: 'red' }">
        {{ dtitle1 }}
      </div>
      <span v-html="des1.replace('\n', '<br>')"></span>
      <div class="colbtns">
        <el-button
          class="join-btn"
          style="font-weight: 700 !important"
          @click="updatePlan()"
          >はい</el-button
        >
        <el-button
          class="join-btn"
          style="font-weight: 700 !important"
          @click="centerDialogVisible1 = false"
          >いいえ</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  plan,
  createPrice,
  createSession,
  createCustomer,
  checkSubscribe,
  canceld,
  updatePlan,
} from "../../api/api.js";
import { revertFreePlan } from "../../utils/global.js";
export default {
  name: "app",
  data() {
    return {
      links: [],
      centerDialogVisible: false,
      centerDialogVisible1: false,
      list: [],
      product_id: "",
      price: "",
      dtitle: "",
      dtitle1: "料金プランの変更",
      des: "",
      des1: "",
      priceYear: 0,
      my_plan: localStorage.getItem("plan"),
      isPaidPlan: false,
      period: "month",
      sub_id: "",
      fromPlan: null,
      toPlan: null,
      revert: revertFreePlan,
    };
  },
  created() {
    let that = this;
    console.log(that.my_plan);
    that.getList();
  },
  components: {},
  methods: {
    numberWithCommas: function (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    goPage: function (page) {
      this.$router.push(page);
    },
    tobuy(id, price, des, title, priceYear) {
      let that = this;
      let customerId = localStorage.getItem("customerId");
      checkSubscribe(customerId).then((res) => {
        console.log("ding", res);
        if (res.result != null) {
          that.isPaidPlan = true;
          that.sub_id = res.result.id;
          that.fromPlan = {
            title: res.result.productListVO.name,
            time: res.result.productListVO.time == "month" ? "月" : "年",
            price:
              res.result.productListVO.time == "month"
                ? Number(res.result.productListVO.priceCount)
                : Number(res.result.productListVO.priceYearCount),
          };
        }
        that.centerDialogVisible = true;
        that.product_id = id;
        that.des = des;
        that.dtitle = title;
        let pri = price.split("円");
        that.price = pri[0];
        that.priceYear = priceYear;

        that.toPlan = {
          title: title,
          time: "月",
          price: 0,
        };
      });
    },
    // 获取充值计划列表
    getList() {
      let that = this;
      plan({}).then((res) => {
        console.log("list", res);
        if (res.code == 200) {
          that.list = res.result;
        }
      });
    },

    updatePlan() {
      let that = this;
      createPrice({
        currency: "jpy",
        interval: that.period,
        product: that.product_id,
        unitAmount: that.period == "month" ? that.price : that.priceYear,
      }).then((res) => {
        console.log("res", res);
        if (res.code == 200) {
          updatePlan({
            customerId: localStorage.getItem("customerId"),
            subId: that.sub_id,
            priceId: res.result.id,
            prodId: that.product_id,
            prodName: that.dtitle,
          }).then((result) => {
            if (result.code == 200) {
              that.$router.push("/pay/choose");
            }
          });
        }
      });
    },

    // 创建价格id，客户id,session
    createPrice(e) {
      let that = this;
      that.period = e;
      // if (that.isPaidPlan) {
      //   that.centerDialogVisible = false;
      //   that.centerDialogVisible1 = true;
      //   //that.updatePlan();
      //   that.toPlan.time = e == "month" ? "月" : "年";
      //   that.toPlan.price =
      //     e == "month" ? Number(that.price) : Number(that.priceYear);

      //   console.log("fromPlan: ", that.fromPlan);
      //   console.log("toPlan: ", that.toPlan);

      //   if (that.toPlan.price > that.fromPlan.price) {
      //     that.des1 =
      //       "「" +
      //       that.fromPlan.title +
      //       "/" +
      //       that.fromPlan.time +
      //       "払い」から「" +
      //       that.toPlan.title +
      //       "/" +
      //       that.toPlan.time +
      //       "払い」に変更します。<br>料金の差額分をお支払いいただきます。<br>本当に料金プランを変更しますか？";
      //   } else {
      //     that.des1 =
      //       "「" +
      //       that.fromPlan.title +
      //       "/" +
      //       that.fromPlan.time +
      //       "払い」から「" +
      //       that.toPlan.title +
      //       "/" +
      //       that.toPlan.time +
      //       "払い」に変更します。<br>払い戻しはいたしかねますのでご了承ください。<br>本当に料金プランを変更しますか？";
      //   }
      // } else {
      {
        createPrice({
          currency: "jpy",
          interval: e,
          product: that.product_id,
          unitAmount: e == "month" ? that.price : that.priceYear,
        }).then((res) => {
          console.log("res", res);
          if (res.code == 200) {
            let customer = localStorage.getItem("customerId");
            if (customer) {
              createSession({
                price: res.result.id,
                customerId: customer,
              }).then((result) => {
                if (result.code == 200) {
                  window.open(result.result.url);
                }
              });
            } else {
              createCustomer({}).then((rest) => {
                console.log(rest);
                if (rest.code == 200) {
                  createSession({
                    price: res.result.id,
                    customerId: rest.result.id,
                  }).then((result) => {
                    if (result.code == 200) {
                      window.open(result.result.url);
                    }
                  });
                }
              });
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/base.css";

.pay-main-warp {
  /* width: 60%; */
  /* height: 692px; */
  flex: 1;
  min-width: 300px;
  max-width: 1200px;
  height: auto;
  margin: 0 auto;
  margin-top: 3%;
  padding: 38px 42px;
  /* padding-bottom: 0 */
}

.colbtns {
  margin-top: 40px;
}

.confirmContent {
  border-radius: 20px;
}

.home-btn {
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 1rem;
  text-align: center;
  padding: 5px 15px;
  width: 130px;
  cursor: pointer;
  background: white;
  color: #63aeb0;
}

.home-btn:hover {
  background: #1e7578;
  color: white;
  border: 1px solid white;
}

.pay-main-warp .title-box {
  text-align: center;
  /* margin-bottom: 40px */
}

.pay-main-warp .title-box .title {
  font-weight: 700;
  font-size: 2rem;
  /* line-height: 35px; */
  color: #fff;
}

.pay-main-warp .lists-box {
  justify-content: space-between;
  flex-wrap: wrap;
}

.pay-main-warp .lists-box .lists-item {
  justify-content: flex-start;
  align-items: flex-start;
  /* flex: 1; */
  position: relative;
  /* height: 450px; */
  box-shadow: 0px 10px 20px #63aeb0;
  /* border: none; */
  border-radius: 12px;
  background: #fff;
  /* margin-right: 30px; */
  width: 20%;
  padding: 20px;
  border: 4px solid transparent;
}

.pay-main-warp .lists-box .lists-item:hover {
  /* border: 4px solid #1E7578 !important; */
  /* cursor: pointer; */
}

.pay-main-warp .lists-box .lists-item:last-child {
  /* margin: 0; */
}

.pay-main-warp .lists-box .lists-item div.title {
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: rgb(44, 44, 44);
  margin-bottom: 8px;
}

.pay-main-warp .lists-box .lists-item div.price-box {
}

.pay-main-warp .lists-box .lists-item div.price-box .price {
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: rgb(44, 44, 44);
  margin-right: 5px;
}

.pay-main-warp .lists-box .lists-item div.price-box .price-unit {
  font-weight: 500;
  font-size: 12px;
  line-height: 38px;
  color: #bebebe;
}

.pay-main-warp .lists-box .lists-item div.des {
  font-size: 14px;
  line-height: 17px;
  color: rgb(44, 44, 44);
  padding: 10px 0;
  min-height: 50px;
}

.pay-main-warp .lists-box .lists-item div.item-list {
  font-weight: 500;
  font-size: 14px;
  line-height: 27px;
  color: rgb(44, 44, 44);
}

.pay-main-warp .lists-box .lists-item .btns-box {
  /* width: calc(100% - 40px); */
  /* position: absolute;
    bottom: 23px; */
  width: 100%;
  flex: 1;
  align-items: flex-end;
}

.pay-main-warp .lists-box .lists-item .btns-box .join-btn {
  border: 1.5px solid #63aeb0;
  box-sizing: border-box;
  border-radius: 4px;
  color: #63aeb0;
  font-weight: 700 !important;
  font-size: 14px;
  width: 100%;
}

.colbtns .join-btn {
  border: 1.5px solid #63aeb0;
  box-sizing: border-box;
  border-radius: 4px;
  color: #63aeb0;
  font-weight: 700 !important;
  font-size: 14px;
  width: 100%;
  margin: 0 0 12px !important;
}

/* .colbtns .join-btn:last-child {
    border: 1.5px solid #63AEB0;
    box-sizing: border-box;
    border-radius: 4px;
    color: #fff;
    font-weight: 700 !important;
    font-size: 14px;
    width: 100%;
    background: #63AEB0;
    margin: 0 0 12px !important;
  } */

.pay-main-warp .lists-box .lists-item .btns-box .join-btn span {
  font-weight: bolder !important;
  font-size: 14px;
}

.pay-main-warp .lists-box .checked {
  background: #1e7578;
  box-shadow: 0px 10px 20px #63aeb0;
}

.pay-main-warp .lists-box .checked div {
  color: #fff !important;
}

.pay-main-warp .lists-box .checked .btns-box .join-btn span {
  color: #1e7578;
}

.purchased-btn {
  background: #83c3c5;
  color: white;
  font-weight: 700;
  font-size: 14px;
  width: 100%;
  border-radius: 4px;
  padding: 12px 20px;
  text-align: center;
  display: inline-block;
  white-space: nowrap;
  height: 39px;
  line-height: 12px;
  margin: 7px 0 !important;
  box-sizing: border-box;
}

.disabled-btn {
  background: red;
  color: yellow;
  font-weight: 700;
  font-size: 14px;
  width: 100%;
  border-radius: 4px;
  padding: 12px 20px;
  text-align: center;
  display: inline-block;
  white-space: nowrap;
  height: 39px;
  line-height: 12px;
  margin: 7px 0 !important;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .pay-main-warp .lists-box .lists-item {
    width: 40%;
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 460px) {
  .pay-main-warp {
    width: 90%;
    padding: 5%;
    height: auto;
    margin-bottom: 3rem;
    margin-top: 3rem;
  }

  .pay-main-warp .lists-box .lists-item {
    /* margin: 0; */
    margin-bottom: 1.5rem;
    /* flex: none; */
    width: 100%;
  }
}

.compare-table-container {
  text-align: center;
  display: flex;
  justify-content: center;
}

.compare-table-container table {
  background: white;
  background-color: transparent;
  box-shadow: 0px 10px 20px #63aeb0;
  border-collapse: collapse;
  /* width: 100%; */
}

.compare-table-container table td,
.compare-table-container table th {
  border: 1px solid #ddd;
  padding: 10px 15px;
  font-weight: bold;
  /* color: #fa9e53; */
  color: red;
}

.compare-table-container table tr:nth-child(odd) {
  background-color: #e8f1fa;
}

.compare-table-container table tr:nth-child(even) {
  background-color: white;
}

.compare-table-container table .row-h {
  color: #577a9a;
}

.compare-table-container table .col-free {
  /* color: #959595;     */
  color: rgb(44, 44, 44);
}

.compare-table-container table .col-h1 {
  background: #577a9a;
  color: white;
}

.compare-table-container table .col-h2 {
  color: #577a9a;
  padding: 15px 20px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?17ebc0f5